import React, { PureComponent } from "react";
import classnames from "classnames";

import { ITags } from "@formant/core/model/ITags";
import { Uuid } from "@formant/core/model/Uuid";

import { DeviceName } from "./DeviceName";
import * as styles from "./DeviceTags.scss";
import { Tags } from "./Tags";
import { Timestamp } from "./Timestamp";

export interface IDeviceTagsProps {
    deviceId: Uuid;
    tags: ITags;
    time?: Date;
    className?: string;
}

export class DeviceTags extends PureComponent<IDeviceTagsProps> {
    public render() {
        const { deviceId, tags, time, className } = this.props;

        return (
            <div className={classnames(styles["device-tags"], className)}>
                <div className={styles.row}>
                    <DeviceName id={deviceId} className={styles.device} />
                    {time && <Timestamp className={styles.time} time={time} />}
                </div>
                <Tags className={styles.tags} tags={tags} singleLine={true} />
            </div>
        );
    }
}
